/**
 * CapaFeaturePopup — popup de un feature de capa informativa (overlay de
 * referencia). Muestra la capa origen (kicker), el nombre del feature y sus
 * atributos crudos (properties jsonb). Reutiliza las clases `.sig-popup`.
 */
import { Popup } from 'react-map-gl';

export interface CapaPopupData {
  lng: number;
  lat: number;
  /** Nombre de la capa (kicker). */
  capaNombre: string;
  /** Nombre/etiqueta del feature (título). */
  featureNombre?: string | null;
  /** Atributos crudos del feature (se listan). */
  properties?: Record<string, unknown> | null;
}

interface CapaFeaturePopupProps {
  data: CapaPopupData;
  onClose: () => void;
}

export function CapaFeaturePopup({ data, onClose }: CapaFeaturePopupProps) {
  const props = data.properties ?? {};
  const entries = Object.entries(props)
    .filter(([k, v]) => k !== 'feature_nombre' && v != null && v !== '')
    .slice(0, 12); // tope defensivo: properties de KML pueden traer decenas de keys

  return (
    <Popup
      longitude={data.lng}
      latitude={data.lat}
      anchor="bottom"
      onClose={onClose}
      closeOnClick={false}
      closeButton={false}
      maxWidth="320px"
      offset={12}
      className="sig-popup-wrap"
    >
      <div className="sig-popup">
        <header className="sig-popup-head">
          <span className="sig-popup-kicker">{data.capaNombre}</span>
          <button
            type="button"
            className="sig-popup-close"
            onClick={onClose}
            aria-label="Cerrar"
            title="Cerrar"
          >
            ×
          </button>
        </header>
        <div className="sig-popup-body">
          <h3 className="sig-popup-title">{data.featureNombre?.trim() || 'Elemento de capa'}</h3>
          {entries.length === 0 ? (
            <div className="sig-popup-row">
              <span className="sig-popup-row-value">Sin atributos adicionales.</span>
            </div>
          ) : (
            entries.map(([k, v]) => (
              <div className="sig-popup-row" key={k}>
                <span className="sig-popup-row-label">{k}</span>
                <span className="sig-popup-row-value">{String(v)}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </Popup>
  );
}
